import type { ReactElement } from 'react'
import type { IABTestVariation } from '~/types/arbitration'

import ABTestVariations from '../../components/ABTestVariations'

import LastUpdatedByCard from '~/components/LastUpdatedByCard'
import { ModalBody, ModalHeader } from '~/components/Modal/Layout'
import Stepper from '~/components/Stepper'
import { usePlacementHistoryQuery } from '~/queries/arbitration'
import dateUtil from '~/utils/dayjs'
import { firstCharToUpperCase } from '~/utils/string'

import './styles.scss'

interface Props {
  appKey: string
  deviceType: string
  navigationGraphOptions: IOption[]
  placementId: string
}

const Step = ({
  navigationGraphOptions,
  variations,
}: {
  navigationGraphOptions: IOption[]
  variations: IABTestVariation
}) => {
  return (
    <div className="variations-step">
      <div className="variations-step__metadata">
        <LastUpdatedByCard
          label={firstCharToUpperCase(dateUtil(variations.created_at).fromNow())}
          labelPosition="top"
          size="small"
          updatedBy={{
            date: variations.created_at_ts,
            name: variations.created_by,
            userId: variations.created_by,
          }}
        />
      </div>
      <ABTestVariations navigationGraphOptions={navigationGraphOptions} variations={variations} />
    </div>
  )
}

const HistoryModalContent = ({ appKey, deviceType, navigationGraphOptions, placementId }: Props): ReactElement => {
  const { data: variationsData } = usePlacementHistoryQuery({ appKey, deviceType, placementId })

  const steps =
    variationsData?.map((variations) => ({
      circleText: `#${variations.version}`,
      content: <Step navigationGraphOptions={navigationGraphOptions} variations={variations} />,
    })) || []

  return (
    <div className="history-modal-content">
      <ModalHeader className="history-modal-content__header">{placementId}</ModalHeader>
      <ModalBody className="history-modal-content__body">
        <Stepper steps={steps} />
      </ModalBody>
    </div>
  )
}

export default HistoryModalContent
